import { useMemo } from 'react';
import { MarginMode } from '@drift-labs/sdk';
import useCurrentUserAccount from '../useCurrentUserAccount';

export const useCurrentUserMarginMode = () => {
	const currentUserAccount = useCurrentUserAccount();

	const marginMode = useMemo(() => {
		if (!currentUserAccount?.client) return MarginMode.DEFAULT;

		return (
			currentUserAccount.client.getUserAccount()?.marginMode ??
			MarginMode.DEFAULT
		);
	}, [currentUserAccount]);

	return marginMode;
};
